import { Component, OnInit, Inject } from '@angular/core';
import { FolderNode, FileDialogData, MediaFile, FileNode } from 'src/app/utils/common-classes';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
import { FileService } from 'src/app/services/File/file.service';
import { UtilsService } from 'src/app/services/Utils/utils.service';


@Component({
  selector: 'app-move-files-dialog',
  templateUrl: './move-files-dialog.component.html',
  styleUrls: ['./move-files-dialog.component.scss'],
  animations: [
    trigger('openClose', [
      state('open', style({
        height: '32px',
        opacity: 1,
      })),
      state('closed', style({
        height: '0px',
        opacity: 0
      })),
      transition('open => closed', [
        animate('1s')
      ]),
      transition('closed => open', [
        animate('0.5s')
      ]),
    ]),
  ],
})
export class MoveFilesDialogComponent implements OnInit {
  public selectedFolder: FolderNode;
  public moveFileError: string;

  constructor(
    public dialogRef: MatDialogRef<MoveFilesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FileDialogData,
    private fileService: FileService,
    public utils: UtilsService) { }

  ngOnInit() {
  }

  public onAbortClick(): void {
    this.dialogRef.close(null);
  }

  public async onSelectClick(): Promise<void> {
    let _self = this;
    let files: Array<FileNode> = _self.data.files;
    if (!files || files.length <= 0) {
      let message: string = await _self.utils.translateKey("dialog.move-files.error.no-file-selected-error");
      _self.utils.showErrorToast(message);
      return Promise.resolve();
    }
    _self.utils.showShortLoader();
    let errors: Array<FileNode> = [];
    let movedFiles: Array<MediaFile> = [];

    for (let i = 0; i < files.length; i++) {
      let file = files[i];
      let mediaFile: MediaFile = new MediaFile();
      mediaFile.mediaFileId = file.mediaFileId;
      mediaFile.mediaFolderId = _self.selectedFolder.mediaFolderId;
      try {
        let movedFile: MediaFile = await _self.fileService.editFile(mediaFile);
        movedFiles.push(movedFile);
      } catch (err) {
        console.error("move file error", file);
        errors.push(file);
      }
    }

    if (errors.length > 0) {
      let filesList: string = "";
      for (let i = 0; i < errors.length; i++) {
        filesList += errors[i].name;
        if (i + 1 != errors.length) {
          filesList += ", "
        }
      }
      let message: string = await _self.utils.translateKeyWithData("dialog.move-files.error.move-error", { files: filesList });
      _self.utils.showErrorToast(message);
    } else {
      let message: string = await _self.utils.translateKey("dialog.move-files.success.move-success");
      _self.utils.showToast(message);
    }
    _self.utils.hideShortLoader();
    _self.dialogRef.close(movedFiles);
  }

  public selectFolder(node: FolderNode): void {
    let _self = this;
    _self.selectedFolder = node;
  }
}
